import { Button, Text } from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import styled, { keyframes } from 'styled-components/macro'

const bounce = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`

export const AnimatedButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7.5px;
  transition: fill 0.3s ease;

  &.animate {
    animation: ${bounce} 0.4s ease;
  }
`

export const ContinueDraftPopupBtn = styled(Button)`
  border-radius: 9999px !important;
  padding: 7.5px;
  cursor: pointer;
  transition: 0.5s;
  width: 80px;
  height: 35px !important;
  font-weight: 500 !important;
  font-size: 17px !important;

  @media (max-width: 473px) {
    font-size: 12.5px !important;
    width: 60px !important;
  }

  @media (max-width: 380px) {
    font-size: 12px !important;
    width: 50px !important;
  }

  :hover {
    background: ${COLORS.gold_hover};
  }
`

export const ContinueDraftPopupText = styled(Text)`
  font-size: 15px !important;

  @media (max-width: 473px) {
    font-size: 13.5px !important;
  }

  @media (max-width: 380px) {
    font-size: 13px !important;
  }
`
